import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import {
  DashboardInvoiceSearchQuery,
  InvoiceCount,
  InvoiceDefaultValue,
  InvoicePages,
  InvoiceChargePayDayQuery,
  InvoiceChargePayDayResponse,
  InvoiceDetailsQuery,
  InvoiceDetails,
  PatchInvoiceDetails,
  PostInvoiceDetails,
  Invoice,
  PostInvoice,
  InvoiceErrorMessage,
  PatchInvoice,
} from '@models/next/Invoice';
import { f } from '@utils/nextForms';
import { z } from 'zod';

export const dashboardInvoiceApis = createApiHooks('', [
  {
    method: 'get',
    path: '/dashboard/invoice',
    parameters: schemaToQueryParameters(DashboardInvoiceSearchQuery),
    response: InvoicePages,
  },
  {
    method: 'get',
    path: '/dashboard/invoice/:id',
    response: Invoice,
  },
  {
    method: 'patch',
    path: '/dashboard/invoice/:id',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PatchInvoice,
      },
    ],
    response: Invoice,
    errors: [
      {
        schema: InvoiceErrorMessage,
        status: 400,
      },
    ],
  },
  {
    method: 'post',
    path: '/dashboard/invoice',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostInvoice,
      },
    ],
    response: Invoice,
    errors: [
      {
        schema: InvoiceErrorMessage,
        status: 400,
      },
    ],
  },
  {
    method: 'get',
    path: '/dashboard/invoice/count',
    parameters: schemaToQueryParameters(DashboardInvoiceSearchQuery),
    response: InvoiceCount,
  },
  {
    method: 'get',
    path: '/dashboard/booking-inquiry/:d2d_no/invoice-default-value',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: InvoiceDefaultValue,
  },
  {
    method: 'get',
    path: '/dashboard/invoice/charge-pay-day',
    parameters: schemaToQueryParameters(InvoiceChargePayDayQuery),
    response: InvoiceChargePayDayResponse,
  },
  {
    method: 'get',
    path: '/dashboard/booking-inquiry/:d2d_no/invoice-detail',
    parameters: schemaToQueryParameters(InvoiceDetailsQuery),
    response: InvoiceDetails.array(),
  },
  {
    method: 'post',
    path: '/dashboard/booking-inquiry/:d2d_no/invoice-detail/',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostInvoiceDetails,
      },
    ],
    response: InvoiceDetails,
  },
  {
    method: 'get',
    path: '/dashboard/invoice-detail/:id',
    response: InvoiceDetails,
  },
  {
    method: 'patch',
    path: '/dashboard/invoice-detail/:id',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PatchInvoiceDetails,
      },
    ],
    response: InvoiceDetails,
  },
  {
    method: 'delete',
    path: '/dashboard/invoice-detail/:id',
    response: z.unknown(),
  },
  {
    method: 'post',
    path: '/dashboard/booking-inquiry/:d2d_no/invoice-detail/lock-china',
    response: z.unknown(),
  },
]);

export const invoiceApis = createApiHooks('', [
  {
    method: 'get',
    path: '/invoice/:id/download',
    parameters: [
      {
        type: 'Path',
        name: 'path',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'get',
    path: '/invoice/v3/:visit_id/download',
    parameters: [
      {
        type: 'Path',
        name: 'visit_id',
        schema: z.string(),
      },
    ],
    response: f.instanceOfBlob(),
  },
]);
